export default "__VITE_ASSET__CBLEpepc__"